import { render, staticRenderFns } from "./receivedDetail.vue?vue&type=template&id=251a3f38&"
import script from "./receivedDetail.vue?vue&type=script&lang=js&"
export * from "./receivedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports